module.exports = __webpack_public_path__ + "img/checkout-icon-generic.e641d4eb.svg";